// extracted by mini-css-extract-plugin
export default {"TermsPage":"TermsAndConditions-module__TermsPage--Vbhh0"};